module.exports = __webpack_public_path__ + "51c42878c38df329394bb0ef15603831.svg";